export enum ProjectStatus {
  NEW = 'NEW',
  MIXER_SOURCE_STORED = 'MIXER_SOURCE_STORED',
  ART_STORED_IN_THE_CLAUD = 'ART_STORED_IN_THE_CLAUD',
  ART_STORED_ON_IPFS = 'ART_STORED_ON_IPFS',
  PUBLISHED_IN_TEST_NET = 'PUBLISHED_IN_TEST_NET',
  PUBLISHED_IN_MAIN_NET = 'PUBLISHED_IN_MAIN_NET',
  ARCHIVED = 'ARCHIVED',
}
